export const CreatorVerticalSeparator: React.FC<any> = () => {
  return <div className="mt-2" />;
};
